import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/view/layout'
import home from '@/view/home'
// import productLayout from '@/view/productLayout'
// import productList from '@/view/productList'
import project from '@/view/project'
import solve from '@/view/solve'
import service from '@/view/service'
import exampleCase from '@/view/exampleCase'
import about from '@/view/about'
import aboutIntroduction from '@/view/aboutIntroduction'
import aboutHonour from '@/view/aboutHonour'
import aboutTalent from '@/view/aboutTalent'
import aboutNews from '@/view/aboutNews'
import aboutDetailNews from '@/view/aboutDetailNews'
import aboutOperative from '@/view/aboutOperative'
import aboutTechnical from '@/view/aboutTechnical'
import aboutUs from '@/view/aboutUs'
Vue.use(Router)

export default new Router({
    mode:'history',
    base:'/',
    routes:[
        {
            path:'/',
            component:layout,
            children:[{
                path:'/',
                name:'首页',
                component:home
            },{
                path:'/project',
                name:'产品中心',
                component:project,
            },{
                path:'/solve',
                name:'解决方案',
                component:solve
            },{
                path:'/service',
                name:'服务支持',
                component:service
            },{
                path:'/exampleCase',
                name:'客户案例',
                component:exampleCase
            },{
                path:'/about',
                name:'关于我们',
                component:about,
                children:[{
                    path:'/aboutIntroduction',
                    name:"关于我们",
                    component:aboutIntroduction
                },{
                    path:'/aboutHonour',
                    name:"关于我们",
                    component:aboutHonour
                },{
                    path:'/aboutTalent',
                    name:"关于我们",
                    component:aboutTalent
                },{
                    path:'/aboutNews',
                    name:"关于我们",
                    component:aboutNews
                },{
                    path:'/aboutDetailNews/:id',
                    name:"aboutDetailNews",
                    component:aboutDetailNews
                },{
                    path:'/aboutOperative',
                    name:"关于我们",
                    component:aboutOperative
                },{
                    path:'/aboutTechnical',
                    name:"关于我们",
                    component:aboutTechnical
                },{
                    path:'/aboutUs',
                    name:"关于我们",
                    component:aboutUs
                }]
            }],
        },
        
    ]
})

